export const PRIMARY_THEME_COLOR = "#3e60f5";
export const SECONDARY_THEME_COLOR = "#5270f6";